import React, { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {  OverviewBigScreenContent, OverviewBigScreenInnerWrapper, CardContent, Icon, StatusBox, AlarmBox, StatusText, OverviewBigScreenWrapper, ScreenBorderTop, ScreenTitleBar, DeviceCardWrapper, CardHeader, Name, InfoLabel, InfoValue, PaginationWrapper, LastLine, ViewDetailButton  } from "./OverviewBigScreen.styled";
import Navigator from "./components/navigator/Navigator";
import DeviceApi from "../../../../api/DeviceApi";
import AlarmEventApi from "../../../../api/AlarmEventApi";
import { Pagination } from 'antd';
import { TablePaginationConfig } from "antd/es/table";
import StringUtils from "../../../../util/StringUtils";
import { CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";

import screenBorderTop from '../../../../assets/images/big-screen/qyc/screen-border-top.png';

interface OverviewBigScreenProps {
    
}

interface AlarmStatusMap {
  [deviceId: string]: boolean;
}

interface TableParams {
    pagination?: TablePaginationConfig;
}

const OverviewBigScreen: React.FC<OverviewBigScreenProps> = (props)=> {

    let deviceApi = new DeviceApi();
    let alarmEventApi = new AlarmEventApi();
    
    let navigate = useNavigate();

    // state 
    let [loading, setLoading] = useState(true);
    let [deviceViews, setDeviceViews] = useState([]);
    let [tableParams, setTableParams] = useState<TableParams>({
            pagination: {
                current: 1,
                pageSize: 9, 
                total: 0,
            },
        });
    let [alarmStatusMap, setAlarmStatusMap] = useState<AlarmStatusMap>({});

    //events
    let loadDeviceViews = async (opts?: { pageNo?: number, pageSize?: number })=> {
        // loading animation
        setLoading(true);

        const pageNo = opts?.pageNo ?? (tableParams.pagination?.current || 1);
        const pageSize = opts?.pageSize ?? (tableParams.pagination?.pageSize || 10);
        
        let deviceViewsPage = (await deviceApi.queryViews({
            deviceTemplateId: "", //qyc device template id 190548060554657792
            productModel: "",
            search: "",
            pageNo: pageNo,
            pageSize: pageSize,
        })).data.data;

        let newTableParams = {pagination: {...tableParams.pagination, current: pageNo, pageSize: pageSize}};
        newTableParams.pagination.total = deviceViewsPage.totalElements;
        setTableParams(newTableParams);
        setDeviceViews(deviceViewsPage.elements);
        setLoading(false);
    };

    let viewDeviceDetails = (device: any)=> {
        navigate(`/big-screen/device-details/${device.device.id}`);
    };


    let onPaginationChange = (page: number, pageSize?: number) => {
        const newPagination = {
            ...tableParams.pagination,
            current: page,
            pageSize: pageSize || tableParams.pagination?.pageSize,
        };
        setTableParams({ pagination: newPagination });
        loadDeviceViews({ pageNo: page, pageSize: newPagination.pageSize });
    };

    let loadAlarmStatus = async (deviceId: string)=> {
        try {
                let resp = await alarmEventApi.queryViews({
                    deviceId: deviceId,
                    acked: false,
                    pageNo: 1,
                    pageSize: 50,
                });
                let elements = resp?.data?.data?.elements || [];
                return elements.length > 0;
            } catch (e) {
                return false; 
            }
    };

    const loadAllAlarmStatus = async (devices: any[]) => {
        if (!devices.length) {
            setAlarmStatusMap({});
            return;
        }

        let newMap: AlarmStatusMap = {};
        for (const record of devices) {
            const deviceId = record.device.id;
            newMap[deviceId] = await loadAlarmStatus(deviceId);
        }
        setAlarmStatusMap(newMap);
    };

    
    // effect
    useEffect(()=> {
        loadDeviceViews();
        loadAllAlarmStatus(deviceViews);

        let refreshTaskId =  window.setInterval(async ()=> {
            await loadDeviceViews();
        }, 5000);

        let originalBackground = document.body.style.backgroundColor;
        document.body.style.backgroundColor = 'rgb(0, 0, 0)';
        return ()=> {
            document.body.style.backgroundColor = originalBackground;
            window.clearInterval(refreshTaskId);
        };
    }, []);

    return (
        <OverviewBigScreenWrapper>
            <OverviewBigScreenInnerWrapper>
                <ScreenTitleBar>
                    <Navigator selected="OVERVIEW"/>                  
                </ScreenTitleBar>

                <ScreenBorderTop src="/static/images/big-screen/qyc/screen-border-top.png" />

                <OverviewBigScreenContent>
                    {deviceViews.length > 0 && 
                        (deviceViews.map(record => (
                                <DeviceCardWrapper key={record.device.id} >
                                    <CardHeader>
                                        <Name>{StringUtils.emptyToSlash(record.device.name)}</Name>
                                            </CardHeader>
                                    <CardContent>
                                        <StatusBox>
                                            {record.device.status === 'ONLINE' ? (
                                            <>
                                                <Icon>
                                                    <CheckCircleFilled className="alarm-icon" style={{ color: '#52c41a' }} />
                                                </Icon>                                                <StatusText>在线</StatusText>
                                            </>
                                            ) : (
                                            <>
                                                <Icon>
                                                    <CloseCircleFilled className="status-icon" style={{ color: '#8c8c8c' }} />
                                                </Icon>
                                                <StatusText>离线</StatusText>
                                            </>
                                            )}
                                        </StatusBox>

                                        <AlarmBox>
                                            {alarmStatusMap[record.device.id] ? (
                                            <>
                                                <Icon>
                                                    <CloseCircleFilled className="alarm-icon" style={{ color: '#ff4d4f' }} />
                                                </Icon>
                                                <StatusText>故障</StatusText>
                                            </>
                                            ) : (
                                            <>
                                                <Icon>
                                                    <CheckCircleFilled className="alarm-icon" style={{ color: '#52c41a' }} />
                                                </Icon>
                                                <StatusText>健康</StatusText>
                                            </>
                                            )}
                                        </AlarmBox>
                                    </CardContent>
                                    <LastLine>
                                        <InfoLabel>
                                            {record.device.status === 'ONLINE' ? '最后更新时间:' : '最后在线时间:'}
                                        </InfoLabel>
                                        <InfoValue>{moment(parseInt(record.node.lastSeenTime)).format("YYYY-MM-DD HH:mm:ss") }</InfoValue>
                                        <ViewDetailButton><a onClick={()=> viewDeviceDetails(record)}>查看详情</a></ViewDetailButton>
                                    </LastLine>
                                </DeviceCardWrapper>
                            ))
                        )
                    }
                </OverviewBigScreenContent>

                {deviceViews.length > 0 && (
                                <PaginationWrapper>
                                    <Pagination
                                        current={tableParams.pagination?.current}
                                        pageSize={tableParams.pagination?.pageSize}
                                        total={tableParams.pagination?.total}
                                        onChange={onPaginationChange}
                                        showQuickJumper
                                        showTotal={(total, range) => 
                                            `第 ${range[0]}-${range[1]} 条/共 ${total} 条`
                                        }
                                    />
                                </PaginationWrapper>
                            )
                }
            </OverviewBigScreenInnerWrapper>
        </OverviewBigScreenWrapper>
    )
};
export default OverviewBigScreen;